import HeaderBar from "../../../Components/UI/headerbar";
import BannersTab from "../components/BannersTab";

const BannersPage = () => {

  return (
    <div className="container-fluid">
      <HeaderBar title="التسويق" content="إدارة الكوبونات والعروض والبانرات." />

      <div className="mt-4">
        <BannersTab />
      </div>
    </div>
  );
};

export default BannersPage;
